import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

//declare var gtag: Function; // Declare gtag function

declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor() {}

  trackButtonClick(buttonName: string) {
    gtag('event', 'click', {
      event_category: 'Click',
      event_label: buttonName,
    });
  }

  logGtagEvent(eventLabel: string, eventValue: any) {
    gtag('event', eventLabel, eventValue);
  }
}
